import { Typography, Table, Tag, Col, Popover, Menu, Spin, Modal } from "antd";
import {
  Metrics,
  Helpers,
  Colors,
  Spacing,
  channelColors as colors,
  Fonts,
  Images,
} from "../../global";
import { Row, Icon, View, LoadingIcon, Graph, Alert } from "../../Components";
import { useEffect, useState, useRef } from "react";
import { useRecoilValue, useRecoilState } from "recoil";
import { useNavigate, useMatch } from "react-router-dom";
import { allSitesAtom } from "../../Atoms/allSitesAtom";
import { useCookies } from "react-cookie";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { ReactComponent as lockIcon } from "../../Assets/SVG/Lock.svg";
import { ReactComponent as backIcon } from "../../Assets/SVG/Back.svg";
import { ReactComponent as emailIcon } from "../../Assets/SVG/Email.svg";
import { ReactComponent as deleteIcon } from "../../Assets/SVG/Trash_Small.svg";
import { ReactComponent as xIcon } from "../../Assets/SVG/CloseSmallB.svg";
import { updateUser, getUser, getUserDeleteToken } from "../../API";
import {
  THP_ENABLED_ARRAY,
  THP_CHANNEL_ICONS,
  THP_DEFAULT_Y_AXIS,
  THP_CH_ENUM,
  THP_ENABLED_CHANNELS,
} from "../../Tools/THP";
import HelperService from "../../Helpers/HelperService";
import { ResponsiveLine } from "@nivo/line";
import { Storage, Auth, Amplify } from "aws-amplify";
import ReportColumns from "../../Components/Column/ReportColumns";
import {
  Group,
  Title,
  Tooltip,
  Button,
  Text,
  Paper,
  Space,
  Avatar,
  TextInput,
  NumberInput,
  SimpleGrid
} from "@mantine/core";
import _, { set } from "lodash";
import { MdKeyboardArrowLeft } from "react-icons/md";

function Reports() {
  const navigate = useNavigate();
  const [allSites, setAllSites] = useRecoilState(allSitesAtom);
  const { user, signOut } = useAuthenticator((context) => [context.user]);
  const [name, setName] = useState();
  const [phone, setPhone] = useState();
  const [address, setAddress] = useState();
  const [email, setEmail] = useState();
  const [image, setImage] = useState(null);
  const [imageUpdate, setImageUpdate] = useState(null);
  const [deleteAccount, setDeleteAccount] = useState(false);
  const [deleteAccountLoading, setDeleteAccountLoading] = useState(false);
  const [updateAccountLoading, setUpdateAccountLoading] = useState(false);
  const [deleteStatus, setDeleteStatus] = useState("");
  const [deleteToken, setDeleteToken] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [password, setPassword] = useState("");
  const [hidePassword, setHidePassword] = useState(false);
  const [error, setError] = useState("");
  const [deleteButtonLoading, setDeleteButtonLoading] = useState(false);
  const [deleteInitiated, setDeleteInitiated] = useState(false);
  const [getTokenError, setGetTokenError] = useState(false);
  const [confirmInitiated, setConfirmInitiated] = useState(false);
  const [confirmation, setConfirmation] = useState(false);
  const [confirmButtonLoading, setConfirmButtonLoading] = useState(false);
  const [deleteError, setDeleteError] = useState(false);
  const [deleteConfirm, setDeleteConfirm] = useState(false);

  const getDBUser = async () => {
    if (
      user &&
      _.has(user, "signInUserSession") &&
      _.has(user.signInUserSession, "idToken") &&
      _.has(user.signInUserSession.idToken, "jwtToken")
    ) {
      let dbUser = await getUser(user.signInUserSession.idToken.jwtToken).then(
        (userData) => userData
      );
      setName(dbUser?.settings?.account?.fullName);
      setPhone(dbUser?.settings?.account?.phone);
      setAddress(dbUser?.settings?.account?.location);
      setEmail(dbUser?.settings?.account?.email);
      console.log("getDBUser Updating AllSites to ", {
        ...allSites,
        user: dbUser,
      });
      setAllSites({ ...allSites, user: dbUser });
      // pullRecipientShares()
    }
  };

  useEffect(() => {
    console.log("useEffect deleteToken");
    if (deleteToken == "" && deleteInitiated) {
      setDeleteButtonLoading(true);
    } else if (
      _.has(deleteToken, "Error") ||
      _.has(deleteToken, "errorMessage")
    ) {
      setDeleteButtonLoading(false);
      if (deleteInitiated) setGetTokenError(true);
      setDeleteInitiated(false);
    } else if (_.has(deleteToken, "deleteToken")) {
      if (deleteToken && deleteInitiated) {
        setDeleteButtonLoading(false);
        setDeleteInitiated(false);
        setDeleteConfirm(true);
      }
    }
  }, [deleteToken, setDeleteButtonLoading]);
  useEffect(() => {
    const getDeleteToken = async () => {
      console.log("useEffect deleteButtonLoading");
      if (deleteButtonLoading && deleteInitiated) {
        try {
          let tempDeleteToken = await getUserDeleteToken(
            user.signInUserSession.idToken.jwtToken,
            password
          );
          setDeleteToken(tempDeleteToken);
        } catch (error) {
          console.log("getUserDeleteToken ERROR:", error);
        }
      }
    };
    getDeleteToken();
  }, [deleteButtonLoading, deleteInitiated]);
  useEffect(() => {
    console.log("useEffect deleteStatus");
    if (deleteStatus == "" && confirmInitiated) {
      setConfirmButtonLoading(true);
    } else if (_.has(deleteStatus, "Error")) {
      setConfirmButtonLoading(false);
      if (confirmInitiated) setDeleteError(true);
      setConfirmInitiated(false);
    } else {
      if (confirmInitiated) {
        setConfirmButtonLoading(false);
        setConfirmInitiated(false);
        navigate("/");
        setAllSites({});
        signOut();
      }
    }
  }, [deleteStatus, setConfirmButtonLoading]);
  useEffect(() => {
    if (allSites?.user?.settings?.account) {
      setName(allSites?.user?.settings?.account?.fullName);
      setPhone(allSites?.user?.settings?.account?.phone);
      setAddress(allSites?.user?.settings?.account?.location);
      setEmail(allSites?.user?.settings?.account?.email);
    } else {
      getDBUser();
    }
  }, [allSites?.user?.settings?.account]);

  const handleImageUpload = async () => {
    console.log("handleImageUpload");
    // if (imageUpdate) {
    //   console.log('imageUpdate:', imageUpdate)
    //   try {
    //     const result = projectId ? (await addProjectImage(projectId, imageUpdate.image, imageUpdate.contentType)) : (await addProjectImage(project_id, imageUpdate.image, imageUpdate.contentType))

    //     console.log('Image uploaded successfully:')
    //   } catch (error) {
    //     console.error('Error uploading image:', error)
    //   }
    // } else {
    //   console.error('No file selected')
    // }
  };

  const deleteAccountHandler = async () => {
    setDeleteAccountLoading(true);
    setDeleteAccount(false);
    // await deleteProject(project_id)
    //     .then(async (res) => {
    //         console.log('deleteProject:', res)
    //         if (res === true) {
    //             await repullAccounts()
    //             setDeleteAccount(false)
    //             navigate('/stores')
    //         }
    //     })
    //     .catch((err) => {
    //         console.log('deleteProject:', err)
    //     })
    setDeleteAccountLoading(false);
  };

  const updateAccountHandler = async () => {
    setUpdateAccountLoading(true);
    await updateUser(null, {
      account: {
        fullName: name,
        phone: phone,
        location: address,
        email: email,
      },
    })
      .then(async (res) => {
        console.log("updateUser:", res);
        await handleImageUpload();
        await getDBUser();
        navigate("/account");
      })
      .catch((err) => {
        console.log("updateUser:", err);
      });
    setUpdateAccountLoading(false);
  };

  const handleNavigateToEditAccount = () => {
    navigate("/account/edit");
    setName(allSites?.user?.settings?.account?.fullName);
    setPhone(allSites?.user?.settings?.account?.phone);
    setAddress(allSites?.user?.settings?.account?.location);
    setEmail(allSites?.user?.settings?.account?.email);
  };

    const formatPhoneNumber = (input) => {
      // Strip all non-numeric characters from the input
      const digits = input.replace(/\D/g, "");

      // Format the digits into the desired format
      const formatted = digits.replace(/(\d{3})(\d{3})(\d{4})/, "($1)$2-$3");

      return formatted;
    };

    const handleInputChange = (e) => {
      const inputValue = e.target.value;
      const formattedValue = formatPhoneNumber(inputValue);
      setPhone(formattedValue);
    };

  return window?.location?.pathname.includes("edit") ? (
    <View
      style={{
        display: "flex",
        flexDirection: "column",
        height: "calc(100vh - 80px - 20px)",
        ...Metrics.horizontalPadding,
        ...Metrics.smallVerticalMargin,
        overflow: "auto",
      }}
    >
      <Group justify="space-between">
        <div>
          <Title order={2}>Edit Account</Title>
          <Text c="dimmed" size="sm">
            Edit your Account details.
          </Text>
        </div>

        <Button
          color={Colors.main}
          variant="outline"
          onClick={() => navigate("/account")}
          radius="sm"
          mr="md"
          h={43}
        >
          <MdKeyboardArrowLeft size="1.6rem" />
          <Text>Back To Account</Text>
        </Button>
      </Group>
      <Space h="md" />
      <Paper p="md">
        <SimpleGrid cols={{ sm: 1, lg: 2 }} spacing="xs" verticalSpacing="lg">
            <TextInput
              label="Name"
              placeholder="First Name Last Name"
              styles={{
                input: { backgroundColor: Colors.gray100 },
              }}
              value={name}
              onChange={(event) => setName(event.currentTarget.value)}
            />
            <TextInput
              label="Address"
              placeholder="123 Any Street, City, State 00000"
              styles={{
                input: { backgroundColor: Colors.gray100 },
              }}
              value={address}
              onChange={(event) => setAddress(event.currentTarget.value)}
            />
         
            <NumberInput
              label="Phone"
              placeholder="(123)456-7890"
              styles={{
                input: { backgroundColor: Colors.gray100 },
              }}
              value={phone}
              onChange={setPhone}
              hideControls
              allowDecimal={false}
              allowNegative={false}
              max={10}
            />
            <TextInput
              label="Email"
              placeholder="example@email.com"
              styles={{
                input: { backgroundColor: Colors.gray100 },
              }}
              value={email}
              onChange={(event) => setEmail(event.currentTarget.value)}
            />
          </SimpleGrid>
          {/* <Row.ImageUpload title={'Profile Photo'} image={Images.user} setImageUpdate={setImageUpdate} width={250} height={250}/> */}
    
        <View style={{ ...Helpers.row, ...Metrics.mdHorizontalPadding }}>
          {/* <Button
                        text={'Delete Account'}
                        style={{ marginRight: Spacing.sm }}
                        variant="error"
                        isLoading={deleteAccountLoading}
                        onPress={()=>setDeleteAccount(true)}
                    /> */}
        </View>
      </Paper>

      <Space h="md" />
      <Group gap="sm">
        <Button
          color={Colors.main}
          onClick={updateAccountHandler}
          loading={updateAccountLoading}
        >
          Save Changes
        </Button>
        {/* 
                <Button 
                    color={Colors.redMain} 
                    onClick={()=> setDeleteAccount(true)} 
                    loading={deleteAccountLoading}>
                    Save Changes
                </Button>
            */}
      </Group>

      {/* <Alert
                visible={deleteAccount}
                setVisible={setDeleteAccount}
                disabled = {password == ''}
                title={'Delete Account'}
                text={'Are you sure you want to delete your account? This action cannot be undone.'}
                loading={deleteAccountLoading}
                onPress={deleteAccountHandler}
            /> */}
      <Modal
        title="Delete Account and Data"
        styles={{ body: { overflowY: "auto", height: "60%" } }}
        open={deleteAccount}
        footer={null}
        onCancel={() => setDeleteAccount(false)}
        onOk={() => setDeleteAccount(false)}
      >
        {deleteConfirm ? (
          <View
            style={{
              display: "flex",
              flexDirection: "column",
              flex: 1,
              height: "100%",
            }}
          >
            <View
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                flex: 1,
                overflow: "auto",
              }}
            >
              <View style={{ width: "100%" }}>
                <Row.Checkbox
                  noBorder
                  title={"Delete Account"}
                  icon={deleteIcon}
                  channelColor={Colors.lightGrey}
                  value={confirmation}
                  label={
                    "Are you sure you want to permanently delete the account? All data will be lost and this step cannot be undone. "
                  }
                  onValueChange={(newValue) => {
                    setConfirmation(newValue.target.checked);
                  }}
                />
              </View>
              <View
                style={{
                  height: 50,
                  justifyContent: "center",
                  alignSelf: "center",
                  width: "87%",
                  ...Metrics.smallBottomMargin,
                }}
              >
                <Button
                  style={Metrics.smallTopMargin}
                  isLoading={confirmButtonLoading}
                  disabled={!confirmation}
                  text="Delete Account and Data"
                  variant="primary"
                  onPress={() => {
                    setConfirmInitiated(true);
                    setConfirmButtonLoading(true);
                  }}
                />
              </View>
            </View>
          </View>
        ) : (
          <View
            style={{
              display: "flex",
              flexDirection: "column",
              flex: 1,
              height: "100%",
            }}
          >
            <View
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                flex: 1,
                overflow: "auto",
              }}
            >
              <View
                style={{
                  display: "flex",
                  width: "100%",
                  flexDirection: "column",
                }}
              >
                <View
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    borderRadius: 5,
                    border: "2px solid",
                    borderColor: Colors.error,
                  }}
                >
                  <Text as="xlarge" color={"error"} weight={"bold"}>
                    {"Warning:"}
                  </Text>
                  <Text style={{ paddingLeft: 5 }} as="xlarge" color={"error"}>
                    {"This action cannot be undone."}
                  </Text>
                </View>
                <Text
                  style={{ paddingTop: 20, paddingBottom: 20 }}
                  as="large"
                  color={"darkGrey"}
                >
                  {"\nThe following will occur if you delete your account:\n"}
                </Text>
                <Text as="large" color="darkGrey">
                  {
                    "• You will lose access to any OneDegree devices and services associated with the closed account, and your data cannot be restored. "
                  }
                </Text>
                <Text as="large" color="darkGrey">
                  {
                    "• Your active units will go offline and will stop logging. You will need to add them to a new account to restart logging.  "
                  }
                </Text>
                <Text as="large" color="darkGrey">
                  {
                    "• You will lose access to any current OneDegree subscriptions. All active subscriptions will be immediately stopped and if applicable, a prorated refund will be applied to the credit card on file.  "
                  }
                </Text>
                <Text as="large" color="darkGrey">
                  {
                    "• You will lose access to any OneDegree Data Files. Any required data should be exported to other formats and stored on your local device before account is deleted.  "
                  }
                </Text>
                <Text
                  style={{ paddingTop: 20, paddingBottom: 20 }}
                  as="large"
                  color={"darkGrey"}
                >
                  {"\nEnter password below to continue:\n"}
                </Text>
              </View>
              <View
                style={{
                  height: 130,
                  justifyContent: "center",
                  width: "100%",
                  ...Metrics.smallBottomMargin,
                }}
              >
                <Row.AuthInput
                  label="Password"
                  icon={emailIcon}
                  value={password}
                  setValue={setPassword}
                  hidden={hidePassword}
                  setHidden={setHidePassword}
                  error={passwordError}
                  setError={setPasswordError}
                />
                <Text color="error" weight="light">
                  {error}
                </Text>
                <Button
                  style={Metrics.smallTopMargin}
                  isLoading={deleteButtonLoading}
                  disabled={password == ""}
                  text="Delete Account and Data"
                  variant="primary"
                  onPress={async () => {
                    setError("");
                    try {
                      setDeleteInitiated(true);
                      setDeleteButtonLoading(true);
                    } catch (error) {
                      console.log(error);
                      switch (error.code) {
                        default:
                          setError(error.message);
                          break;
                      }
                    }
                  }}
                />
              </View>
            </View>
          </View>
        )}
      </Modal>
      <Alert
        visible={getTokenError}
        setVisible={setGetTokenError}
        title="Account Delete Request Error"
        text={
          deleteToken.Error
            ? deleteToken.Error
            : deleteToken.errorMessage
            ? deleteToken.errorMessage
            : ""
        }
        oneButton={true}
        onPress={() => {
          setGetTokenError(false);
        }}
      />
      <Alert
        visible={deleteError}
        setVisible={setDeleteError}
        title="Account Delete Request Error"
        text={deleteStatus.Error}
        oneButton={true}
        onPress={() => {
          setDeleteError(false);
        }}
      />
    </View>
  ) : (
    <>
      <Group justify="space-between">
        <div>
          <Title order={2}>Account</Title>
          <Text c="dimmed" size="sm">
            View and change account settings.
          </Text>
        </div>

        <Tooltip label="Edit Your Account">
          <Button
            variant="default"
            onClick={handleNavigateToEditAccount}
            radius="sm"
            mr="md"
          >
            Edit Account
          </Button>
        </Tooltip>
      </Group>
      <Space h="md" />

      <Paper p="md">
        <Group>
          <Avatar size={200} src={Images.user} />
          <div>
            <Title order={3}>
              {allSites?.user?.settings?.account?.fullName}
            </Title>
            <Title order={3}>
              {allSites?.user?.settings?.account?.location}
            </Title>
            <Text c={Colors.textSecondary}>
              {"Phone: " + allSites?.user?.settings?.account?.phone}
            </Text>
            <Text c={Colors.textSecondary}>
              {"Email: " + allSites?.user?.settings?.account?.email}
            </Text>
          </div>
        </Group>

        <Group p="md" gap="xs">
          <Icon svg={lockIcon} size="sm" color={Colors.main} />
          <Title order={3} c={Colors.main}>
            {"Administrator"}
          </Title>
        </Group>
      </Paper>
    </>
  );
}

export default Reports;
